<template>
  <div></div>
</template>
<script>
import apiUser from '@/api/user'
import { setToken, setUserId } from '@/utils/auth'

export default {
  mounted () {
    this.login()
  },
  methods: {
    login () {
      apiUser.login({
        token: this.$route.query.token,
        provider: 'tourist'
      })
        .then((r) => {
          this.$store.commit('SET_TOKEN', r.data)
          setToken(r.data.bearerToken)
          setUserId(r.data.userId)
          this.ListMainMenu().then(res => {
            this.$router.push({ name: 'openScreen', query: { id: '梅雨大屏' } })
            this.loading = false
          })
        })
        .catch(res => {
          this.loading = false
          const msg = res.response.data.responseStatus.message
          this.$notify.error({ title: '错误', message: msg })
        })
    }
  }
}
</script>
